import { AxiosResponse } from "axios";
import axiosInstance from "../../../api/axios";
import { ProjectType } from "../../../utils/types/cycle";

export type interpretation =
  | "Shift"
  | "Trend"
  | "Too Many Runs"
  | "Too Few Runs"
  | "Astronomical Data Point"
  | "";

export type InterpretationDescription = {
  [key in interpretation]: string;
};
export const interpretationDescription: { [key: string]: string } = {
  Shift:
    "Six or more consecutive points either all above or all below the median.",
  Trend: "Trend in the data",
  TooManyRuns: "Too many runs",
  TooFewRuns: "Too few runs",
  AstronomicalDataPoint: "detecting unusually large or small numbers",
};

export const getDataEntryProjects = async (): Promise<ProjectType[] | null> => {
  try {
    const response = await axiosInstance.get("/project/data-entry-projects");
    console.log("success", response.data);
    return response.data;
  } catch (error) {
    console.error("error", error);
    return null;
  }
};

export const addDataEntry = async (values: any) => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.post(
      `/measurement-result`,
      values
    );
    return response.data;
  } catch (error: any) {
    return null;
  }
};
export const getMeasurementResults = async (
  id: number
): Promise<any[] | null> => {
  try {
    const response = await axiosInstance.get(`/measurement/forResult/${id}`);
    console.log("success", response.data);
    return response.data;
  } catch (error) {
    console.error("error", error);
    return null;
  }
};

export const areConsecutive = (arr: number[]) => {
  if (arr.length < 2) return false;
  for (let i = 1; i < arr.length; i++) {
    if (arr[i] !== arr[i - 1] + 1) {
      return false;
    }
  }
  return true;
};

export const arePointsIncreasing = (
  indexes: number[],
  performances: number[]
) => {
  for (let i = 1; i < indexes.length; i++) {
    if (performances[indexes[i]] <= performances[indexes[i - 1]]) {
      return false;
    }
  }
  return true;
};

export const getNumberOfCutsToMedian = (data: any[], median: number) => {
  let numberOfCuts = 0;

  for (let i = 0; i < data.length - 1; i++) {
    if (
      (data[i].result > median && data[i + 1].result < median) ||
      (data[i].result < median && data[i + 1].result > median)
    ) {
      numberOfCuts++;
    }
  }

  return numberOfCuts;
};

export const hasAstronomicalDataPoint = (data: any[], threshold: number) => {
  for (let i = 0; i < data.length; i++) {
    if (Math.abs(data[i].result) > threshold) {
      return true;
    }
  }
  return false;
};

export const getRunChartInterpretation = (data: any[], median: number) => {
  let interpretation: interpretation[] = [];
  let description: string[] = [];

  let performances = data.map((value) => value.result);

  let aboveMedianIndexs = [];
  let belowMedianIndexs = [];
  for (let i = 0; i < performances.length; i++) {
    if (performances[i] > median) {
      aboveMedianIndexs.push(i);
    } else {
      belowMedianIndexs.push(i);
    }
  }
  if (
    (aboveMedianIndexs.length >= 6 && areConsecutive(aboveMedianIndexs)) ||
    (belowMedianIndexs.length >= 6 && areConsecutive(belowMedianIndexs))
  ) {
    interpretation.push("Shift");
    description.push(interpretationDescription["Shift"?.replace(/\s/g, "")]);
  }

  if (
    aboveMedianIndexs.length >= 5 &&
    areConsecutive(aboveMedianIndexs) &&
    arePointsIncreasing(aboveMedianIndexs, performances)
  ) {
    interpretation.push("Trend");
    description.push(interpretationDescription["Trend"?.replace(/\s/g, "")]);
  }

  if (getNumberOfCutsToMedian(data, median) + 1 <= 5) {
    interpretation.push("Too Few Runs");
    description.push(
      interpretationDescription["Too Few Runs"?.replace(/\s/g, "")]
    );
  }

  if (getNumberOfCutsToMedian(data, median) + 1 >= data.length / 2) {
    interpretation.push("Too Many Runs");
    description.push(
      interpretationDescription["Too Many Runs"?.replace(/\s/g, "")]
    );
  }

  if (hasAstronomicalDataPoint(data, median)) {
    interpretation.push("Astronomical Data Point");
    description.push(
      interpretationDescription["Astronomical Data Point"?.replace(/\s/g, "")]
    );
  }

  return {
    interpretation,
    description: description,
  };
};
